export enum OrganisationType {
  ORG_UNIT_NUM_TYPE = 4,
  DEPARTMENT_NUM_TYPE = 7,
}
